module.exports = __webpack_public_path__ + "static/media/banner_home_01.34805dd2.png";